<template>
    <div>
        <div class="mainimagecontainer header-background">
            <div class="mainimage d-flex flex-row justify-content-around">
                <div class="centercolumn d-flex flex-column justify-content-around">
                    <div
                        v-if="gobiIdsUnique.length"
                        class="d-flex flex-row justify-content-center flex-wrap"
                    >
                        <div
                            v-for="gobiId in gobiIdsUnique"
                            :id="`gobi${gobiId}`"
                            :key="gobiId"
                        ></div>
                    </div>
                    <div v-if="tagline" class="tagline">{{ tagline }}</div>
                </div>
            </div>
        </div>
        <div class="leftrightmargin">
            <MainLayout hide-on-mobile="left right">
                <div slot="top">
                    <div v-if="hasOwnVFairs">
                        <h5 class="mt-5">Upcoming Virtual Events</h5>
                        <VFairList
                            class="mt-4"
                            with-layout-toggle
                            :data="ownVFairs"
                            :is-loading="loading()"
                        />
                    </div>
                </div>
                <div slot="top">
                    <div v-if="hasOtherVFairs">
                        <h5 class="mt-5">Digital Campus Visits</h5>
                        <VFairList
                            class="mt-4"
                            with-layout-toggle
                            :data="otherVFairs"
                            :is-loading="loading()"
                        />
                    </div>
                </div>
            </MainLayout>
        </div>
    </div>
</template>

<script>
import { Bubbles } from '@gobistories/gobi-web-integration';
import MainLayout from '../../components/layouts/mainlayout/MainLayout.vue';
import VFairList from '../vfairs/list/components/VFairList.vue';
import SchoolService from '~/services/SchoolService';

export default {
    name: 'Home',
    components: {
        MainLayout,
        VFairList,
    },
    data() {
        return {
            tagline: this.$getCustomProperty('tagline'),
            gobiIds: this.$getCustomProperty('gobiIds'),
            organizationId: SchoolService.getCurrentSchoolId(),
        };
    },
    computed: {
        vfairs() {
            if (this.organizationId) {
                return this.$interfaces.vfair.get({
                    reactive: true,
                    organization_id: this.organizationId,
                });
            } else {
                return {
                    data: [],
                    loading: true,
                };
            }
        },
        ownVFairs() {
            return this.sortVFairs(this.vfairs.data).filter(vFair => vFair.visibility === 2);
        },
        hasOwnVFairs() {
            return this.ownVFairs.length > 0;
        },
        otherVFairs() {
            return this.sortVFairs(this.vfairs.data).filter(
                vFair => vFair.visibility === 0 || vFair.visibility === 1
            );
        },
        hasOtherVFairs() {
            return this.otherVFairs.length > 0;
        },
        gobiIdsUnique() {
            if (this.gobiIds && this.gobiIds.length) {
                let unique = new Set(this.gobiIds);
                return [...unique];
            } else {
                return [];
            }
        },
    },
    mounted() {
        this.$interfaces.logInModule.setDisabledPopup();
        if (this.gobiIdsUnique.length) {
            this.gobiIds.forEach(gobiId => {
                new Bubbles({
                    container: `#gobi${gobiId}`,
                    playerOptions: {
                        autoStart: true,
                        logo: false,
                    },
                    bubbleSize: '120px',
                    color: 'rgba(0, 0, 0, 0)',
                    animatedBubble: true,
                    stories: [{ id: gobiId }],
                });
            });
        }
    },
    methods: {
        sortVFairs(vFairs) {
            return vFairs
                .filter(item => {
                    let check = item.start;
                    if (item.end) {
                        check = item.end;
                    }
                    let now = new Date();
                    let then = new Date(check);
                    return now <= then && item.active;
                })
                .sort((a, b) => (a.start > b.start ? 1 : -1));
        },

        loading() {
            return this.vfairs.loading;
        },
    },
};
</script>

<style scoped>
.mainimagecontainer {
    width: 100%;
    min-height: 400px;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    padding-top: 5%;
    padding-bottom: 6%;
}

.centercolumn {
    width: 60%;
    height: 100%;
}
.tagline {
    font-family: 'Open Sans', Helvetica, Arial, Lucida, sans-serif;
    font-weight: 700;
    font-size: 45px;
    text-align: center;
    color: #fff;
}
.leftrightmargin {
    margin-left: 2%;
    margin-right: 2%;
}
</style>
